import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImg from '../Img/Login-img.png'
import { getDecryptedUserFromCookie } from './utils/getCookie';
import CryptoJS from "crypto-js";
import { Eye, EyeOff } from 'lucide-react';
import { usePermissions } from '../context/PermissionContext';


const Login = () => {
  const [phone, setPhone] = useState(''); // State for phone number
  const [password, setPassword] = useState(''); // State for password
  const [showResendButton, setShowResendButton] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [otpworld1, setOtpworld1] = useState(false);
  const [otpworld2, setOtpworld2] = useState(false);
  const [confirmObj, setConfirmObj] = useState("");
  const navigate = useNavigate();
  const urlmain = process.env.REACT_APP_LINK
  const [load, setLoad] = useState(true);
  const res = CryptoJS.AES.encrypt(JSON.stringify({ email: "test@example.com" }), "your-secret").toString();

  const user = getDecryptedUserFromCookie();
  const [showPassword, setShowPassword] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [userId, setUserId] = useState()
  const { storeEncryptedPermissions, refreshPermissions } = usePermissions();

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };



  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);

  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };


  const handleCheckVerify = async (user_id) => {
    setUserId(user_id)
    try {
      const response = await fetch(`${urlmain}/two-step/login/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ user_id })
      })

      const res = await response.json();
      console.log(res);
      if (res.verify) {
        setOtpModal(true)
        // handleVerifyOtp(user_id);
        toast.success('Otp sent successful!');
        setLoad(true);
      } else {
        toast.success('Login successful!');
        setLoad(true);
        navigate("/");
      }

    } catch (error) {
      console.error(error)
    }
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(false)
    try {
      const response = await fetch(`${urlmain}/stafflogin`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: phone,
          password: password
        })
      })
      const res = await response.json();
      console.log(res);
      // const user = res.user;
      // const token = res?.token
      if (res.success) {
        localStorage.setItem("2xgxgshdugyywerw12eccom", JSON.stringify(res.user))
        localStorage.setItem('accessToken', res.token);
        if (res.permissions) {
          storeEncryptedPermissions(res.permissions);
        }
        await refreshPermissions();
        navigate("/");
        console.log(res.user)
      } else {
        toast.error(`${res.message}`);
        setLoad(true)
      }

      console.log('Login successful with:', { phone, password });

    } catch (error) {
      toast.error(`${error}`);
      setLoad(true)
    }
    finally {
      setLoad(true)
    }
  };

  const handleVerifyOtp = async (user_id) => {
    try {
      const response = await fetch(`${urlmain}/two-step/login/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ otp, user_id: userId }),
      });

      const res = await response.json();
      if (response.ok) {
        // setEnabled(!enabled);
        // toast.success(
        //   `Two-step verification ${!enabled ? "enabled" : "disabled"}!`
        // );
        navigate("/");
        setOtpModal(false);
        toast.success('Login successful!');
        setOtp("");
      } else {
        toast.error(res.message || "Invalid OTP");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  }



  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      {/* <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}> */}
      <div className="login-bg">
        <div className="login-img">
          <img src={loginImg} alt="" />
        </div>
        <div className="login-box">
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="phone"
              placeholder="Email"
              value={phone}
              onChange={handlePhoneChange}
            />
            {/* <input
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={handlePasswordChange}
            /> */}
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={password}
                onChange={handlePasswordChange}
              />
              {/* <span className="toggle-icon" onClick={togglePassword}>
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span> */}
            </div>
            <p className="register">
              By continuing, I agree to the <Link to='/terms-and-conditions'>Terms of use</Link> & <Link to='/privacy-policy'>Privacy Policy</Link>
            </p>
            {
              load ? <button type="submit">Continue</button> :
                <button type="button" disabled>Loading...</button>
            }

          </form>

          {otpModal && (
            <div className="setting-cart-modal">
              <div className="setting-cart-modal-content">
                <h3 className="setting-payment-modal-title" style={{ textAlign: "center" }}>
                  OTP Verification
                </h3>

                <label className="setting-payment-label">Enter OTP</label>
                <div style={{ position: "relative" }}>
                  <input
                    type="text"
                    className="setting-payment-input"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleVerifyOtp();
                    }}
                  />
                  {/* <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                    }}
                    onClick={() => setShowOtp((prev) => !prev)}
                  >
                    {showOtp ? <EyeOff /> : <Eye />}
                  </span> */}
                </div>

                <div className="setting-payment-modal-actions">
                  <button className="setting-payment-save"
                    onClick={handleVerifyOtp}
                  >
                    Verify
                  </button>
                  <button className="setting-payment-cancel" onClick={() => setOtpModal(false)}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* <p className="divider">Or sign in with</p>
                    <div className="google">
                        Sign in with Google
                    </div> */}
          {/* <p className="register">
            Don't have an account? <Link to='/register'>Register now</Link>
          </p> */}
          <Link style={{ textDecoration: "none" }} to='/reset'><p className="reset-btn">Forget Password?</p></Link>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default Login;
